import Image from '@/app/common/components/Image'
import { ErrorCard } from '@/common/components/ErrorCard'
import LoadingCard from '@/common/components/LoadingCard'
import { ProviderQueries } from '@/queries/providers/queries'
import { RootState } from '@/storage/store'
import { useQuery } from '@tanstack/react-query'
import { format, parseISO } from 'date-fns'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

const DocumentsTabPage = () => {
  const location = useLocation()
  const { selectedProgramYear } = useSelector((s: RootState) => s.programs)
  const providerId = location.pathname.split('/')[2]
  const {
    data: providerInfo,
    status,
    error,
  } = useQuery(
    ProviderQueries.getProviderById(selectedProgramYear?.id ?? 0, providerId)
  )

  if (status === 'error') {
    return <ErrorCard text={error?.message} />
  }

  if (status === 'pending') {
    return <LoadingCard title="Loading Provider Details" />
  }

  return (
    <div>
      <ul
        role="list"
        className="grid grid-cols-2 gap-6 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 mt-5"
      >
        {providerInfo?.files &&
          providerInfo?.files.map((doc) => (
            <div key={doc.id} className="relative">
              <div>
                <Image
                  className="shadow-lg w-32 h-32"
                  allowZoom={true}
                  path={doc.path ?? ''}
                  width={'100%'}
                  alt={''}
                />
              </div>
              <div className="flex flex-col">
                {doc.expiration_date && (
                  <span className="text-gray-600 text-sm">
                    Expires:{' '}
                    {format(parseISO(doc?.expiration_date), 'LLLL d, yyyy')}
                  </span>
                )}

                {doc.provider_document_type_name && (
                  <span className="text-gray-600 text-sm">
                    Type: {doc?.provider_document_type_name}
                  </span>
                )}
              </div>
            </div>
          ))}
      </ul>
    </div>
  )
}

export default DocumentsTabPage
